var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.geojson !== null)?_c('l-geo-json',{attrs:{"geojson":_vm.geojson,"options":{ style: _vm.styleFunction }}}):_vm._e(),(_vm.selectedDateRiskData)?_c('KouzuiKikikuruLayer'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }